import React from 'react';

interface IProps {
  src?: any;
  alt?: string;
  style?: any;
  handleClick?: any;
}
export const Image = ({ src, alt = '', style, handleClick }: IProps) => {
  return <img src={src} alt={alt} style={{ ...style }} onClick={handleClick} />;
};
